/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// import Image from 'next/image';
// import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import styles from '../contentPage.module.scss';

import Image from 'next/image';

import NextSeoWrapper from '@/components/NextSeoWrapper';
import PageContainer from '@/components/PageContainer';
import { getLanguageAlternates } from '@/utils/locale';
import { getCanonicalUrl } from '@/utils/navigation';

const path = '/donation';
const DonationPage = () => {
    const { lang } = useTranslation('donation');


    return (
        <>
            <NextSeoWrapper
                title="donation"
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                <div className={styles.historyPage}>

                    <div style={{ textAlign: 'center', padding: "10px" }}>
                        <Image src="/images/donate.png" width={799} height={960} layout="responsive" alt="Donate" />
                    </div>

                </div>
            </PageContainer>
        </>
    );
};

export default DonationPage;
